import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { useSelector, useDispatch } from 'react-redux';
import { HelperStyles } from '@stencil/commonstories/src/HelperStyles';
import {
  seoStateSelector,
  flightSearchDataSelector,
  hasSeoDataSelector,
  flavourSelector,
  offerOverlaySelector
} from '@stencil/flights-seo-reducers/src/SRP/redux/selectors';
import * as S from '@stencil/dstories/src/components/SRP/SeoSrpLayout/seo-srp-layout.styles';
import SomethingWentWrong from '@stencil/something-went-wrong';
import BreadCrumbs from '@stencil/commonstories/src/components/Seo/breadcrumbs/breadcrumbs';
import {
  gaPageViewThunk,
  gaPushPageInfoThunk,
  gaGenericEventThunk
} from '@stencil/flights-ga-thunks';
import SearchWidget from '../search-widget/search-widget';
import SeoFlightsToFlightsFromLeft from './seo-flights-to-flights-from-left';
import SeoFlightsToFlightsFromRight from './seo-flights-to-flights-from-right';
import Footer from '@stencil/dstories/src/components/SRP/SeoFooter/footer';
import OfferOverlay from '../../../../../../flights/dstories/src/components/SRP/offer-overlay/offer-overlay';
//import Footer from '@stencil/footer';

const SeoFlightsToFlightsFromDweb = props => {
  const dispatch = useDispatch();

  const seoState = useSelector(seoStateSelector);
  const { meta, meta_title, metaLinks, language, breadcrumb, footer_data } = seoState;

  const flavour = useSelector(flavourSelector);
  const offerOverlayData = useSelector(offerOverlaySelector);

  useEffect(() => {
    const flavourWeb = flavour === 'mobile' ? 'mWeb' : 'dWeb';
    dispatch(gaPushPageInfoThunk('SRPSeo', flightSearchDataSelector, flavourWeb));
    dispatch(gaPageViewThunk('FlightsSRPSeo', flightSearchDataSelector));
    gaGenericEventThunk('Seo_Flight_City_Page');
  }, []);

  const hasSeoData = useSelector(hasSeoDataSelector);
  if (!hasSeoData) {
    return (
      <div
        style={{
          padding: '10px',
          backgroundColor: 'white',
          height: '100%'
        }}
      >
        <SomethingWentWrong
          containerStyles={{
            height: '100vh'
          }}
        />
      </div>
    );
  }

  return (
    <>
      <HelperStyles />
      <Helmet title={meta_title} meta={meta} link={metaLinks} />
      <div className="WrapperSc">
        <S.Wrapper className="width100 flexCol">
          <SearchWidget language={language} />
          <S.Container>
            <BreadCrumbs breadcrumb={breadcrumb} isDweb={true} />
            <S.RightWrap className="flexCol">
              <SeoFlightsToFlightsFromRight />
            </S.RightWrap>
            <S.LeftWrap>
              <SeoFlightsToFlightsFromLeft />
            </S.LeftWrap>
          </S.Container>
          <OfferOverlay offerOverlayData={offerOverlayData} />
        </S.Wrapper>
        <Footer html={footer_data} />
      </div>
    </>
  );
};

export default SeoFlightsToFlightsFromDweb;
